module.exports = __webpack_public_path__ + "static/media/pov_whole_GreatIcosahedron.9ae21e3a.png";